import React from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import WPEMigrationReadiness from './../wpengine/wpenginemigrationreadiness'

class WPEngineMigrationReadinessModal extends React.Component {	
	close = () => {
		this.props.actions.closeModal()
	}
	render() {
		const { history, migrate } = this.props
		return <Modal show={true} className="wpe-mig-readiness-modal">
			<Modal.Body>
				<WPEMigrationReadiness history={history} migrate={migrate} close={this.close}/>
			</Modal.Body>
		</Modal>
	}
}

WPEngineMigrationReadinessModal.propTypes = {
	actions: PropTypes.object,
	history: PropTypes.object
}

export default WPEngineMigrationReadinessModal
